"use strict";
import { jsx } from "react/jsx-runtime";
import { forwardRef, Children } from "react";
import { clsx } from "../../../../styles/clsx.js";
import { utilClasses } from "../../../../styles/utility.js";
import classes from "./TabList.module.css.js";
const MOBILE_AUTOSTRETCH_ITEMS_MAX = 3;
const TabList = forwardRef(
  ({ className, style = {}, stretched, children, ...props }, ref) => {
    const numberOfTabs = Children.toArray(children).length;
    const tabWidth = Math.floor(100 / numberOfTabs);
    const stretchOnMobile = numberOfTabs <= MOBILE_AUTOSTRETCH_ITEMS_MAX;
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        className: clsx(classes.wrapper, utilClasses.hideScrollbar, className),
        style: { ...style, "--tab-list-width": tabWidth },
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: clsx(
              classes.base,
              stretched && classes.stretched,
              stretchOnMobile && classes["stretched-mobile"]
            ),
            ...props,
            role: "tablist",
            children
          }
        )
      }
    );
  }
);
export {
  TabList
};
